import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#1D2D50] bg-[#0A1128]">
      <div className="container mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-[#A0AABF] text-sm font-['Manrope']">
          &copy; 2026 Trademark Legal Forum. All rights reserved.
        </p>
        <div className="flex items-center gap-4 text-sm">
          <Link
            to="/privacy-policy"
            data-testid="footer-privacy-link"
            className="text-[#A0AABF] hover:text-[#D4AF37] transition-colors"
          >
            Privacy Policy
          </Link>
          <span className="text-[#1D2D50]">|</span>
          <Link
            to="/terms-of-service"
            data-testid="footer-terms-link"
            className="text-[#A0AABF] hover:text-[#D4AF37] transition-colors"
          >
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
}
